import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch, ref } from "vue";
import TimePartsComp from "../../../commons/product/auction/countdown/time-parts.vue";
import { TimeDuration } from "@and3k5/timespan.js";
import { type TimeParts } from "../../../commons/product/auction/countdown/types";
import { getDateParts } from "../../../commons/product/auction/countdown";
import labels from "../../shared/labels";


export default /*@__PURE__*/_defineComponent({
  __name: 'countdown-time',
  props: {
    secondsLeft: {
        type: Number,
        required: true,
    },
    blank: Boolean,
},
  setup(__props) {

const props = __props;

const duration = new TimeDuration(0);
const timeParts = ref<TimeParts>({
    days: {
        unit: "\u00a0",
        value: undefined,
    },
    hours: {
        unit: "\u00a0",
        value: undefined,
    },
    minutes: {
        unit: "\u00a0",
        value: undefined,
    },
    seconds: {
        unit: "\u00a0",
        value: undefined,
    },
});

watch(
    () => props.secondsLeft,
    (newValue) => {
        if (props.blank) return;
        if (newValue != null) {
            duration.setTotalSeconds(newValue);
            timeParts.value = getDateParts(duration, {
                ...labels.frontendProductList.productSpecs.time,
                minutes:
                    labels.frontendProductList.productSpecs.time.minutes.substring(
                        0,
                        3
                    ),
                seconds:
                    labels.frontendProductList.productSpecs.time.seconds.substring(
                        0,
                        3
                    ),
            });
        }
    },
    {
        immediate: true,
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TimePartsComp, {
    value: timeParts.value,
    "seconds-left": __props.secondsLeft
  }, null, 8 /* PROPS */, ["value", "seconds-left"]))
}
}

})